module.exports = __webpack_public_path__ + "img/scan-empty-state.8a560e13.svg";